define('models/MessageModel',['underscore','ObjectModel','LocalStorage','app','moment'],function (_,ObjectModel,LocalStorage,app,moment) {
    //
    // Model Message
    //

    // HOME
    var HOME_HEADER_MESSAGE = 'home_header_widget';
    var HOME_BANNER_MESSAGE = 'home_top_banner';

    // LISTING
    var LISTING_BANNER_MESSAGE = 'listing_top_banner';
    var LISTING_INFO_BAR_MESSAGE = 'listing_info_bar';

    // SHOP
    var SHOP_INFO_MESSAGE = 'shop_info';

    var MESSAGES_LOCAL_STORAGE_KEY = 'SushiShopMessagesDismissed';
    var MESSAGE_DATE_FORMAT = 'YYYY-MM-DD hh:mm:ss';
    var MESSAGE_TIME_FORMAT = 'hh:mm';

    var MessageModelPrototype = {

        name:'MessageModel',
        route: 'apiMessageModel',
        idAttribute: 'id_sushi_message',
        defaults:{
            message:'',
            link:'',
            dismissed:false,
            color:false,
            priority:0,
            priority_with_id:0,
        },

        initialize:function(){
            var model = this;
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(model,arguments);
            model.set({
                dismissed:LocalStorage.isInList(MESSAGES_LOCAL_STORAGE_KEY,model.id)
            });
            model.on('change:priority',function(){
                model.updateComparator();
            });
            model.updateComparator();
            //
        },

        updateComparator:function(){
            var intId = parseInt(this.id),
                priority_with_id = (this.getPriority() + 1 + (10000/(-10000-intId)));
            this.set('priority_with_id',priority_with_id);
        },

        getPriority:function(){
            return parseInt(this.get('priority')) || 0;
        },

        dismiss:function(){
            // TODO
            this.set('dismissed', true);
            LocalStorage.addInList(MESSAGES_LOCAL_STORAGE_KEY, this.id)
        },

        isDismissed: function () {
            return this.get('dismissed');
        },

        validateContext:function(){
            var model = this,
                validate;

            validate = model.validateTime()
                && model.validateRestrictions();

            return validate;
        },

        validateRestrictions:function(){
            var model = this, cart, zone, isModeActive, isVAE, vae_vad,
                active_web = model.get('active_web') === '1',
                norestriction = model.get('norestriction') === '1',
                validate;

            if(!(validate = active_web)){
                // ignore non active_web
            }else if(!(validate = norestriction)){
                // si il y a des restrictions
                cart = app.getCart();
                isVAE = cart.isVAE();
                vae_vad = isVAE?'vae':'vad';
                zone = model.get('zone')[vae_vad];
                isModeActive = model.get('active_'+vae_vad);
                if(isVAE){
                    // restriction Click & Collect
                    var store = cart.getStore();
                    validate = isModeActive && !!store && _.contains(zone.store,store.id);
                }else{
                    // restriction Livraison
                    var district = cart.getDistrictId();
                    if(district){
                        validate = isModeActive && _.contains(zone.district,district);
                    }else{
                        validate = isModeActive && _.contains(zone.postcode,cart.getPostcodeId());
                    }
                }
            }

            return validate;
        },

        validateTime:function(){
            // vérifie si le message doit être affiché dans le temps actuel
            var model = this,
                timemode = model.get('timemode'),
                validate = false;
            // suivant le mode de message
            if(timemode === 'ponct'){
                // ponctuel
                validate = this.validateFromTo();
            }else{
                // périodique
                validate = this.validatePeriod();
            }
            return validate;
        },

        validateFromTo: function(){
              var model = this,
                  from = moment(model.get('from'),MESSAGE_DATE_FORMAT),
                  to = moment(model.get('to'),MESSAGE_DATE_FORMAT);
              //
              return from.isBefore() && to.isAfter();
        },

        validatePeriod: function(){
            var model = this,
                validate,
                schedule = model.get('schedule'),
                scheduleDay = schedule ? schedule[moment().day()] : false,
                isNowLunch = app.isNowLunch(),
                am_pm = isNowLunch?'am':'pm';
            validate = !!scheduleDay && ( // si on a des données sur le jour
                // et que ou bien
                (scheduleDay['all_'+am_pm] === '1') // tout le service
                     ||
                (
                    // ou bien on est entre le début et la fin de la période défini par le message
                    moment(scheduleDay['time_deb_'+am_pm],MESSAGE_TIME_FORMAT).isBefore()
                    && moment(scheduleDay['time_end_'+am_pm],MESSAGE_TIME_FORMAT).isAfter()
                )
            );
            //
            return validate;
        },

        getPage:function(){
            var page = '';
            switch(this.get('location')){
                case HOME_HEADER_MESSAGE:
                case HOME_BANNER_MESSAGE:
                    page = 'home';
                    break;
                case LISTING_BANNER_MESSAGE:
                case LISTING_INFO_BAR_MESSAGE:
                    page = 'listing';
                    break;
                case SHOP_INFO_MESSAGE:
                    page = 'shop';
                    break;
            }
            return page;
        },

        getCssColorAttr: function(prop){
            // return html attr style string
            var color = this.get('color') || '';
            prop = prop || 'background-color';
            return color ? ' style="'+prop+':'+color+'" ' :'';
        },

        getIconHtml: function(classes, defaultIcon){
            // return html attr style string
            var icon = this.get('icon') || defaultIcon || '',
                html = '';
            if(icon){
                classes = classes || '';
                html = '<span class="notifications '+classes+' icon-'+icon+'"></span>';
            }
            return html;
            //icon ? ' style="'+prop+':'+color+'" ' :'';
        },
        getMessageHtml:function(){
            var model = this,
                message = model.get('message'),
                link = model.get('link');
            if(!!link){
                message = '<a href="'+link+'">'+message+'</a>';
            }
            return message;
        },
        clickClass:function(){
            return !!this.get('link') ? 'message--clickable':'';
        }

    };

    var MessageModel = ObjectModel.extend(MessageModelPrototype);

    return MessageModel;
});
